import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DateTime } from 'luxon';

import { CoachSettingsGeneralCertificatesController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-certificates/coach-settings-general-certificates.controller';

@Component({
	selector: 'spr-coach-settings-general-certificates-certificate',
	templateUrl:
		'./coach-settings-general-certificates-certificate.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachSettingsGeneralCertificatesCertificateComponent {
	@Input() form!: FormGroup;

	public referenceDateRange: string;

	constructor(public controller: CoachSettingsGeneralCertificatesController) {
		const referenceMaxYear = DateTime.now().year;
		const referenceMinYear = DateTime.now().minus({ years: 70 }).year;
		this.referenceDateRange = `${referenceMinYear}:${referenceMaxYear}`;
	}
}
